import Typography from '@components/v2/ui/Typography/Typography';
import { Box, Stack } from '@mui/material';
import { BookOpen } from 'lucide-react';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import { SuggestedCatalog } from '../../globalSearch.types';
import Thumbnail from '../Thumbnail';

const ROW_HEIGHT = 36;
const THUMBNAIL_SIZE = 20;

interface SuggestedCatalogsProps {
  catalogs: SuggestedCatalog[];
  onSelect: (catalogId: string) => void;
}

function SuggestedCatalogs({ catalogs, onSelect }: SuggestedCatalogsProps) {
  const { translate } = useTranslation();

  return (
    <Box test-id="global-search-suggested-catalogs">
      <Typography variant="body2" color="text.secondary" sx={{ px: 1, py: 0.5 }}>
        {translate(LangEnum.GLOBAL_SEARCH_SUGGESTED_CATALOGS_TITLE)}
      </Typography>
      <Stack>
        {catalogs.map((catalog) => (
          <Box
            key={catalog.id}
            component="button"
            type="button"
            test-id={`global-search-suggested-catalog-${catalog.id}`}
            onClick={() => onSelect(catalog.id)}
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              minHeight: ROW_HEIGHT,
              px: 1,
              border: 'none',
              background: 'none',
              font: 'inherit',
              textAlign: 'left',
              cursor: 'pointer',
              borderRadius: `${theme.shape.borderRadiusLg}px`,
              color: theme.palette.text.secondary,
              '&:hover': { backgroundColor: theme.palette.action.hover },
            })}
          >
            <Thumbnail
              imageUrl={catalog.imageUrl}
              alt=""
              size={THUMBNAIL_SIZE}
              fallbackIcon={BookOpen}
            />
            <Typography variant="body1" color="text.primary" noWrap sx={{ flex: 1, minWidth: 0 }}>
              {catalog.name}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}

export default SuggestedCatalogs;
